export const ru = {
    'auth-as': 'Авторизирован как',
    'bd-config': 'Конфигурация БД',
    'beta-number': 'Номер беты',
    'disable-captcha': 'Отключить капчу',
    'dump-vars': 'Включить dump_vars',
    'fake-auth': 'Фейковая авторизация',
    features: 'Список фичей',
    role: 'Роль',
    shard: 'Шард'
};
